import { render, staticRenderFns } from "./InterfaceSettingsLogos.vue?vue&type=template&id=37a94ad6&scoped=true"
import script from "./InterfaceSettingsLogos.vue?vue&type=script&lang=js"
export * from "./InterfaceSettingsLogos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a94ad6",
  null
  
)

export default component.exports